module.exports = __webpack_public_path__ + "static/media/search-active.5a89851c.svg";